// import logo from './logo.svg';
import "./App.css";
import React from "react";
// import InputManager from "./InputManager";
import ShapeDiverLoad from "./view/ShapeDiverViewer";
import urlBanner from "./static/PIVOT-PAN-ZOOM.png";

// var URL = require('url').URL;



const TICKET_ID =
  // imageWall_0.5.19
  // "dcd992256ffbcd36a6c0b58ad90db1359eccdbf7a3cbc8a6395e8f2c3757c05191f3accb709327e11a157082f0b07fb1810776d11b5deb1d7b625023442817b83ef39d46adbfe98a863e7f4a5d219225a6d24d744570dc39a9c2e2868c30039d68eb615d93f6dc-a91d5379bb157bc107a9e03f50d30502"
  // "27712ad7fb7863e320a08d04d66a5657636baea7d181f8849fe54ad761a0345d8c6e2fa85138ef213879cfd15d356792ec3a764fd0453abb625dfe5d708ff8708bb20e5bcdd077f849f9c55fbf2d7c6bbf4325f2363349778747884f4f512782616bdc68be47c0-bd86a10385b49869c43d4c29a0909c46"
// "5579b8b73b928eb465af8274b24118fec95a16be73e8d17a5452e8d1d0686f4864b2c262cfec3f8b52c9db1718b5e8512deb39c6cf76f131f59a4cf933d33f6f61492b0880fd8fc27d9085379047a9405bd8134f3f80aea59536503d21ab957658dcfa3b472215-fe3a52df49d5603600d0622f402d9476"
  // "7581f82fec5689b8c95f1bd626df466ac70ad7e2ec1d9347204a8308850b0894c6b0a16af9c76038b09dc1a4c0ab28dfa6505e982c80357846677becaaca5be613a21b04140d8b135e4f0d1df6e2de384f6024dbfa09ed1050711304a761ec5a25f1c1ac2942fa-429f07565cb268aa7318d0a8e7282107"
"13100ec77a339e4642f95f45b4892ab6e49ad4da510f1f473e7c6bd67e03c5a548112ac4427af01ded52279d5dafa3a1707c7a45ec2a6195a66881d2682ccb330fc8f67c62392939bbefc2af9a5d47ad79f1ec61401e06175f7b03b778411582d88e26bcc88cd4-b0d8ccf23ae8d1797945e281046c3d82"


function ShapeDiverWrapper(props) {
  return <ShapeDiverLoad ticket={props.ticket} liveLink={props.liveLink} />;
}

function App() {
  const [hasHovered, setHasHovered] = React.useState(false);
  const [hoverAreaVisible, setHoverAreaVisible] = React.useState(true);

  const handleHoverAreaEnter = () => {
    setHasHovered(true);
    setHoverAreaVisible(false);
  };

  return (
    <div style={{ position: "relative" }}>
      {hoverAreaVisible && (
        <div
          className="hover-area"
          onMouseEnter={handleHoverAreaEnter}
          style={{
            position: "absolute",
            top: 15,
            bottom: 0,
            left: 0,
            right: 0,
            zIndex: 2, // set zIndex to a higher value
          }}
        />
      )}

      {!hasHovered && (
        <div
          style={{
            backgroundImage: `url("${urlBanner}")`,

            opacity: 0.6,
            backgroundSize: "contain",
            backgroundRepeat: "no-repeat",

            backgroundPosition: "center",
            top: "50%",
            right: "20%",
            transform: "translate(20%, -50%)",
            width: "60vw",
            height: "60vh",
            position: "absolute",
            zIndex: 1, // set zIndex to a lower value
            transition: "opacity 1.5s ease-in-out", // add transition property
          }}
        />
      )}

      <ShapeDiverWrapper ticket={TICKET_ID} liveLink={true} />
    </div>
  );
}

export default App;
